import {combineReducers} from '@reduxjs/toolkit';
import studentReducer from "./studentReducer";
import teacherReducer from "./teacherReducer";
import adminReducer from "./adminReducer";

const rootReducer = combineReducers({
  studentReducer: studentReducer,
  teacherReducer: teacherReducer,
  adminReducer: adminReducer
});

export default rootReducer;